import { type IconProps } from '@chakra-ui/react/icon';
import { forwardRef, type ForwardRefExoticComponent, type ReactNode, type Ref } from 'react';

type BitkitIconRenderFn<P> = (props: P, ref: Ref<SVGSVGElement>) => ReactNode;

/**
 * Wraps a forwardRef icon component with the BitkitIconComponent brand.
 * The brand exists at the type level only — no runtime overhead.
 *
 * Use this when creating a custom icon component compatible with BitkitIconComponent:
 * @example
 * const MyIcon = bitkitIcon(function MyIcon(props, ref) {
 *   return <Icon asChild ref={ref} {...props}><MySvg /></Icon>;
 * });
 */
export function bitkitIcon<P extends IconProps & { size?: '16' | '24' }>(
  render: BitkitIconRenderFn<P>,
): ForwardRefExoticComponent<P> & { __bitkitIcon: true } {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const component = forwardRef(render as any) as ForwardRefExoticComponent<P> & { __bitkitIcon: true };
  component.displayName = render.name;
  return component;
}
